import { useState, type FormEvent } from 'react';
import { Link, useLocation, useNavigate } from 'react-router';
import { useAuth } from '@/auth/useAuth';
import { Button, Screen, TextField } from '../../ui';

export default function SignIn() {
  const { signIn } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const from = (location.state as { from?: string } | null)?.from ?? '/';

  async function submit(e: FormEvent): Promise<void> {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await signIn(email.trim(), password);
      navigate(from, { replace: true });
    } catch (err) {
      // The service's own message, not a generic one: "Incorrect username or password"
      // and "User is not confirmed" call for different actions from the person reading it.
      setError(err instanceof Error ? err.message : 'Could not sign you in.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <Screen title="Sign in">
      <form onSubmit={submit} noValidate>
        <TextField label="Email" type="email" value={email} onChangeText={setEmail} placeholder="you@example.com" />
        <TextField label="Password" type="password" value={password} onChangeText={setPassword} />
        {error && <p role="alert" className="type-caption field-error-text">{error}</p>}
        <Button title="Sign in" type="submit" loading={busy} />
      </form>
      <p className="type-body auth-links">
        <Link to="/forgot-password">Forgot your password?</Link>
      </p>
      <p className="type-body auth-links">
        New here? <Link to="/sign-up">Create an account</Link>
      </p>
    </Screen>
  );
}
